export const ABOUT_FORM_NAME = 'about';



// WEBPACK FOOTER //
// ./src/modules/AboutForm/constants.js